import { Currency, getBonusSettlementCustomerTranslationId } from '@synergy/models';
import { DownloadIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { IconButton, Stack, Tooltip } from '@mui/material';
import {
    OverviewTableComponent,
    OverviewTableComponentProps,
    PoolChip,
    PoolTableColumn,
    PoolTableRow,
} from '@synergy/components';
import { PoolFormattedMessage, PoolTypography } from '@synergy/components-next';

import { PoolCustomerBonusSettlementSupplier } from '../../models/pool-customer-bonus-settlement-supplier';

export interface BonusSettlementSupplierOverviewTableProps
    extends OverviewTableComponentProps<PoolCustomerBonusSettlementSupplier> {
    currency: Currency;
    onExport(customerId: number): void;
}

export class PoolBonusSettlementPoolTable extends OverviewTableComponent<
    PoolCustomerBonusSettlementSupplier,
    BonusSettlementSupplierOverviewTableProps
> {
    handleExport = (
        e: React.MouseEvent<HTMLButtonElement>,
        bonusSettlementSupplier: PoolCustomerBonusSettlementSupplier
    ) => {
        e.stopPropagation();
        this.props.onExport(bonusSettlementSupplier.customerId);
    };

    protected columns: PoolTableColumn[] = [
        {
            id: 'status',
            label: <FormattedMessage id="app.bonusSettlements.detail.table.status" />,
            sortable: false,
            width: '10%',
        },
        {
            id: 'customer',
            label: <FormattedMessage id="app.bonusSettlements.detail.table.member" />,
            sortable: false,
            width: '30%',
        },
        {
            id: 'city',
            label: <PoolFormattedMessage id="app.bonusSettlements.detail.table.city" />,
            sortable: false,
            width: '10%',
        },
        {
            id: 'download',
            sortable: false,
            width: '1%',
        },
    ];

    protected getRows = () =>
        this.props.data.items.map<PoolTableRow>(bonusSettlementSupplier => {
            return {
                id: bonusSettlementSupplier.customerId,
                status: (
                    <PoolChip
                        status={bonusSettlementSupplier.status}
                        listItem={true}
                        label={
                            <FormattedMessage
                                id={getBonusSettlementCustomerTranslationId(bonusSettlementSupplier.status)}
                            />
                        }
                        sx={{ maxWidth: 188 }}
                    />
                ),
                customer: (
                    <Stack>
                        {bonusSettlementSupplier.customerName}
                        <PoolTypography typography="body2" component="span" color="grey.800">
                            {bonusSettlementSupplier.customerId}
                        </PoolTypography>
                    </Stack>
                ),
                city: bonusSettlementSupplier.city,
                download: (
                    <Tooltip
                        title={<FormattedMessage id="app.bonusSettlements.detail.member.export" />}
                        placement="top"
                    >
                        <IconButton onClick={e => this.handleExport(e, bonusSettlementSupplier)}>
                            <DownloadIcon sx={{ color: theme => theme.palette.common.black }} />
                        </IconButton>
                    </Tooltip>
                ),
            };
        });
}
